import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, GiftIcon } from 'lucide-react';
export function BonusGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const scrollToIndex = (index: number) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth;
      scrollRef.current.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const cardWidth = scrollRef.current.offsetWidth;
      const newIndex = Math.round(scrollLeft / cardWidth);
      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        const nextIndex = (activeIndex + 1) % bonuses.length;
        scrollToIndex(nextIndex);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [activeIndex, isAutoPlaying]);
  const bonuses = [{
    id: 1,
    badge: 'BONUS 1',
    title: 'Conexiones PRO Sin Fallas',
    description: 'Aprende a conectar tiras LED, empalmes y uniones correctas sin errores para garantizar la durabilidad de tus trabajos.',
    image: 'https://cdn.magicpatterns.com/uploads/84u9VCBsLpijCXuzGwbgBJ/no_modificar_nada_de_nada_202605232240.webp',
    originalPrice: '15.000'
  }, {
    id: 2,
    badge: 'BONUS 2',
    title: 'Cartelería LED Profesional',
    description: 'Aprende desde lo básico hasta crear cartelería LED profesional paso a paso, dominando las técnicas más avanzadas del mercado.',
    image: 'https://cdn.magicpatterns.com/uploads/ksD1FmSWKVD25f5QbKbt7d/Bonus_2_compri.webp',
    originalPrice: '12.500'
  }, {
    id: 3,
    badge: 'BONUS 3',
    title: 'Sistema 3D de Cero a Profesional',
    description: 'Aprende desde lo básico hasta dominar la creación de letras y carteles 3D profesionales paso a paso con acabados de lujo.',
    image: 'https://cdn.magicpatterns.com/uploads/h8PPXg83CwwdLFkihSAAzn/Bonus_3_compri.webp',
    originalPrice: '18.000'
  }, {
    id: 4,
    badge: 'BONUS 4',
    title: 'Tips y Recomendaciones',
    description: 'Consejos prácticos, trucos y recomendaciones clave para evitar errores comunes y lograr acabados profesionales en cada proyecto.',
    image: 'https://cdn.magicpatterns.com/uploads/mKf3z6vufeBqCfubdA69PW/bonus_4_compri.webp',
    originalPrice: '14.500'
  }, {
    id: 5,
    badge: 'BONUS 5',
    title: 'Sistema de Marketing Visual',
    description: 'Aprende a comunicar, atraer y convertir más clientes con estrategias de marketing visual efectivas para negocios que destacan.',
    image: 'https://cdn.magicpatterns.com/uploads/3D9mc8QXWVkJVezyvNfmuq/Bonus_5_compri.webp',
    originalPrice: '11.000'
  }, {
    id: 6,
    badge: 'BONUS 6',
    title: 'Proveedores y Materiales',
    description: 'Todo lo que necesitas para tus proyectos. Acceso a nuestra lista exclusiva de proveedores confiables y materiales de alta calidad.',
    image: 'https://cdn.magicpatterns.com/uploads/eiHvcsMKVwMmUKKte9GGWF/Bonus_6_compri.webp',
    originalPrice: '20.000'
  }];
  return <section className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-white/5 pt-[30px] pb-[30px]" data-id="element-91">
      <div className="max-w-7xl mx-auto" data-id="element-92">
        <div className="text-center mb-16" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#ec4899]/10 border border-[#ec4899]/30 text-[#ec4899] text-sm font-black mb-6 tracking-widest" data-id="element-94">
            <GiftIcon className="w-4 h-4" data-id="element-95" />
            OFERTA EXCLUSIVA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight" data-id="element-96">
            TODO LO QUE <span className="text-[#00f0ff]" data-id="element-97">TE LLEVÁS HOY</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-98">
            El curso completo más 6 bonus de regalo por un precio único
          </motion.p>
        </div>

        <div className="relative group/carousel" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)} data-id="element-99">
          <div className="absolute top-1/2 -left-4 md:-left-12 -translate-y-1/2 z-20" data-id="element-100">
            <button onClick={() => scrollToIndex(Math.max(0, activeIndex - 1))} disabled={activeIndex === 0} className={`p-4 rounded-full bg-[#1a0b2e] border border-white/10 text-white transition-all ${activeIndex === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:border-[#ec4899] hover:text-[#ec4899] shadow-[0_0_15px_rgba(236,72,153,0.3)]'}`} data-id="element-101">
              <ChevronLeft className="w-6 h-6" data-id="element-102" />
            </button>
          </div>

          <div className="absolute top-1/2 -right-4 md:-right-12 -translate-y-1/2 z-20" data-id="element-103">
            <button onClick={() => scrollToIndex(Math.min(bonuses.length - 1, activeIndex + 1))} disabled={activeIndex === bonuses.length - 1} className={`p-4 rounded-full bg-[#1a0b2e] border border-white/10 text-white transition-all ${activeIndex === bonuses.length - 1 ? 'opacity-30 cursor-not-allowed' : 'hover:border-[#ec4899] hover:text-[#ec4899] shadow-[0_0_15px_rgba(236,72,153,0.3)]'}`} data-id="element-104">
              <ChevronRight className="w-6 h-6" data-id="element-105" />
            </button>
          </div>

          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-8 pb-10" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-106">
            {bonuses.map((bonus, index) => <div key={bonus.id} className="min-w-full md:min-w-[calc(50%-16px)] lg:min-w-[calc(33.333%-22px)] snap-center" data-id="element-107">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index * 0.1
            }} className="h-full bg-[#1a0b2e]/60 backdrop-blur-md border border-white/10 rounded-[2.5rem] p-8 hover:border-[#ec4899]/50 transition-all duration-500 hover:shadow-[0_20px_60px_rgba(236,72,153,0.15)] group flex flex-col" data-id="element-108">
                  <div className="inline-flex self-start items-center gap-2 px-4 py-1.5 rounded-full bg-[#ec4899]/10 border border-[#ec4899]/30 text-[#ec4899] text-xs font-black mb-6 tracking-widest" data-id="element-109">
                    {bonus.badge}
                  </div>

                  <h3 className="text-white font-black text-2xl mb-4 leading-tight group-hover:text-[#00f0ff] transition-colors" data-id="element-110">
                    {bonus.title}
                  </h3>

                  <p className="text-gray-400 text-base mb-8 leading-relaxed flex-grow font-medium" data-id="element-111">
                    {bonus.description}
                  </p>

                  <div className="relative mb-8 overflow-hidden rounded-2xl group-hover:scale-105 transition-transform duration-500 shadow-2xl" data-id="element-112">
                    <img src={bonus.image} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-113" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e] via-transparent to-transparent opacity-40" data-id="element-114" />
                  </div>

                  <div className="text-center mt-auto" data-id="element-115">
                    <p className="text-gray-500 text-xs font-bold mb-2 tracking-widest uppercase" data-id="element-116">
                      VALOR REAL:
                    </p>
                    <p className="text-2xl text-gray-600 line-through font-black decoration-[#ec4899]/60 decoration-4 mb-4" data-id="element-117">
                      {bonus.originalPrice} ARS
                    </p>
                    <div className="bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] text-white font-black text-xl py-4 px-6 rounded-2xl uppercase tracking-widest shadow-[0_5px_20px_rgba(236,72,153,0.3)]" data-id="element-118">
                      INCLUIDO HOY
                    </div>
                  </div>
                </motion.div>
              </div>)}
          </div>

          <div className="flex justify-center gap-3 mt-4" data-id="element-119">
            {bonuses.map((_, index) => <button key={index} onClick={() => scrollToIndex(index)} className={`h-2.5 rounded-full transition-all duration-300 ${activeIndex === index ? 'w-10 bg-[#ec4899] shadow-[0_0_10px_rgba(236,72,153,0.5)]' : 'w-2.5 bg-white/10 hover:bg-white/20'}`} data-id="element-120" />)}
          </div>
        </div>
      </div>
    </section>;
}